export const environment = {
  name: "prod",
  production: true,
  coverallURL: 'https://commercial.mapfreconnect.com/mic/portal/index.jsp',
  coverallDashboardURL:'https://commercial.mapfreconnect.com/mic/portal/dashboardDeepLink.jsp',
  e2vLink:'https://e2value.com/',
  clientId:'bf4c93c4-3a76-42da-a47c-34ce7e98fe43',
  tenantId:'5cc6c66d-ffb2-469f-9385-cda840e57836',
  PmpUrl:'https://gfbdbcluqb.execute-api.us-east-1.amazonaws.com/pro/interactions',
  entraScope:'openid profile email api://bf4c93c4-3a76-42da-a47c-34ce7e98fe43/mbop-api',
  nodeserver: 'https://bop.mapfreconnect.com/api/'
};
